export const version = 'v2.2.4-2217-g23747c02d'
